import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../components/LayoutComponents/Navbar/Navbar";
import Sidebar from "../../components/LayoutComponents/Sidebar/Sidebar";
import { useMediaQuery } from "@mui/material";
import { useAuth } from "../../Authentication/AuthContext";

function Dashboard() {
  // Define media queries for mobile and tablet screens
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:960px)"); // Typical tablet breakpoint (960px)
  const { userRole } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();


  const ownerAllowedRoutes = ["user-management", "setting", 'add-user'];

  useEffect(() => {
    if (!userRole) userRole = localStorage.getItem("userRole");

    if (
      userRole === "owner" &&
      !ownerAllowedRoutes.includes(location.pathname.split("/").pop())
    ) {
      navigate("/dashboard/user-management");
    }
  }, [userRole, location.pathname, navigate]);

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      gap={3}
      backgroundColor="#F4F7F7"
    >
      <Sidebar />
      <Box flex={10.2}>
        <Navbar />
        <Outlet />
      </Box>
    </Box>
  );
}

export default Dashboard;
